<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-01-28 11:01:06
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-01-28 12:55:34
-->
<!--  -->
<template>
  <div class="PasswordLogin">
    <Form :model="form" :rules="rules" v-model="regular">
      <Input
        label="手机号"
        class="temr"
        :readonly="true"
        disabled
        v-model="form.phone"
        :reg="rules.phone"
        :maxlength="12"
        type="text"
        labelWidth="90px"
        placeholder="请输入手机号"
      />
      <message-code
        class="temr"
        label="验证码"
        :reg="rules.smsCode"
        placeholder="请输入验证码"
        v-model="form.smsCode"
        v-bind="$listeners"
        :params="{
          type: 11,
          method: 'getSmsWithLogin',
        }"
      ></message-code>
      <Input
        label="新密码"
        class="temr"
        v-model="form.password"
        :reg="rules.password"
        :maxlength="12"
        :type="type"
        labelWidth="90px"
        placeholder="请输入新密码"
      />
      <Input
        label="确认密码"
        class="temr"
        v-model="form.passwordCopy"
        :reg="rules.passwordCopy"
        :maxlength="12"
        :type="type"
        labelWidth="90px"
        placeholder="请输入新密码"
      />
    </Form>
    <Button
      :loading="loading"
      loadingText="提交中..."
      type="danger"
      text="保存"
      :disabled="!regular"
      class="nextStep"
      :click="nextStep"
    />

    <self-popup @define="define" v-model="ShowContent"></self-popup>
  </div>
</template>

<script>
import { rules } from '@/utils';
import Form from '@/components/Form.vue';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import JSencrypt from '@/utils/rsa/jsencrypt';
import { mapState } from 'vuex';
import MessageCode from './MessageCode.vue';

export default {
  name: 'PasswordLogin',

  data() {
    return {
      type: 'password',
      form: {
        phone: '',
        smsCode: '',
        passwordCopy: '',
        password: '',
      },
      rules: {
        passwordCopy: rules.password,
        password: rules.password,
        smsCode: rules.captchaRequired,
      },
      loading: false,
      regular: false,
      ShowContent: '',
    };
  },
  components: {
    Form,
    Input,
    Button,
    MessageCode,
  },
  mounted() {
    const { phone } = this.$route.query;
    this.form.phone = phone;
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  methods: {

    nextStep() {
      const flag = this.form.passwordCopy !== this.form.password;
      if (flag) {
        (this.ShowContent = '两次密码输入不一致');
        return;
      }
      const obj = {
        smsCode: this.form.smsCode,
        password: this.form.password,
      };
      const encrypt = new JSencrypt();
      encrypt.setPublicKey(
        'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ==',
      );
      // obj.phone = encrypt.encrypt(obj.phone);
      obj.password = encrypt.encrypt(obj.password);
      this.$api.PublicPage.updatePassword(JSON.stringify(obj))
        .then((res) => {
          if (res.success) {
            this.ShowContent = '重置密码成功';
          } else {
            this.ShowContent = res.returnMessage;
          }
        })
        .catch((e) => {
          this.ShowContent = e;
        });
    },
    define(obj) {
      if (obj.value === '重置密码成功') {
        this.$router.push('/supermarket/v2/login');
      }
      this.ShowContent = '';
      // eslint-disable-next-line no-unused-expressions
      obj.cb && obj.cb();
    },
  },
};
</script>
<style scoped>
.nextStep {
  margin-top: 32px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;

  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
</style>
